import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MDBCol, MDBContainer, MDBNotification, MDBRow } from 'mdbreact'
import React, { useEffect, useState } from 'react'
import { arrayMove, arrayRemove, List } from 'react-movable'
import { Button, ButtonIcon, Card, Lookup, Option, Picklist } from 'react-rainbow-components'
import { LookupValue } from 'react-rainbow-components/components/types'
import { RequestInit, RequestInitWithBody } from '../shared/RequestInit'

const EdiTop30: React.FC<any> = () => {
  const [value, setValue] = useState<any>("")
  const [Error, setError] = useState<boolean>(false);
  const [pending, setPending] = useState<boolean>(false);
  const [Options, setOption] = useState<{ Id: number, label: string, photo: string, artiste: string }[] | undefined>(undefined);
  const [Loading, setLoading] = useState<boolean>(false)
  const [Music, setMusic] = useState<null | { Id: number, label: string, photo: string, index: number }[]>(null);
  const [OriginalMusic, setOriginalMusic] = useState<null | { Id: number, label: string, photo: string, index: number }[]>(null);
  const [DropDown, setDropDown] = useState<{ name: any, label: string | undefined, options: (number | undefined)[] }>({ name: '1', label: '1', options: [1, 2, 3, 4, 5, 6, , 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] })
  const [Update, setUpdate] = useState<{ updated: boolean, message: string, error: boolean }>({ updated: false, error: false, message: 'une erreur est survenu' })

  const fetchMusic = async () => {
    await fetch('https://admin.radioemotion.be/api/music/top30/getall', RequestInit as RequestInit)
      .then(response => response.json())
      .then(response => {
        if (response.response === true) {
          setOriginalMusic(response.data)
          console.log(response.data)
          setMusic(response.data)
          setPending(false)
        }
      })
      .catch(err => {
        console.log(err)
        setPending(false)
      })
  }
  useEffect(() => {
    setPending(true)
    fetchMusic()
  }, []);

  const search = (value: string) => {
    setLoading(true)
    console.log(value)
    if (value === "") {
      setValue("")
      setLoading(false)
    } else {
      const fetchtDropDown = async () => {
        await fetch('https://admin.radioemotion.be/api/music/top30/dropdown', RequestInitWithBody({ body: { value: value }, type: 'POST' }) as RequestInit)
          .then(response => response.json())
          .then(response => {
            console.log(response.data)
            setOption(response.data)
            setLoading(false)
          })
          .catch(err => {
            console.log(err)
            setPending(false)
            setLoading(false)
          })
      }
      fetchtDropDown()
    }
  }
  const autoUpdate = (array: { Id: number, label: string, photo: string, index: number }[], oldIndex?: number, newIndex?: number) => {
    if (array?.length === 30) {
      setUpdate({ ...Update, updated: false, error: false })
      const updateTop30 = async () => {
        await fetch('https://admin.radioemotion.be/api/music/top30/update', RequestInitWithBody({ body: { data: array }, type: 'PATCH' }) as RequestInit)
          .then(response => response.json())
          .then(response => {
            if (response.response === true) {
              setUpdate({ ...Update, updated: true })
              setMusic(array)
            } else {
              setUpdate({ ...Update, error: true, updated: false })
            }
          })
          .catch(err => {
            console.log(err)
            setUpdate({ ...Update, error: true, updated: false })
          })
      }
      updateTop30();
    }
  }
  const AddMusic = () => {
    if (Music && Music?.length < 30) {
      let newArr = [...Music];
      newArr.splice(Number(DropDown.label) - 1, 0, { Id: value.Id, label: value.label, index: 2, photo: value.photo })
      setMusic(newArr);
      autoUpdate(newArr)
      setError(false)
    } else {
      setError(true)
    }
  }
  useEffect(() => {
console.log(Music)
  }, [Music])
  const remove = (value:any) =>{
    if(Music !== null){
      let filteredArray = Music.filter(item => item.Id !== value.Id)
      setMusic(filteredArray);
    }
  }
  return (
    <>

      { Update.updated ?
        <MDBNotification
          icon="check"
          iconClassName="success-dark-text"
          bodyClassName="px-5 font-weight-bold text-white success-color-dark"
          show
          fade
          autohide={3000}
          title={""}
          message={"Mise à jour réussie"}
          text={"maintenant"}
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            zIndex: 9999
          }}
        />
        :
        Update.error ?
          <MDBNotification
            icon="times"
            iconClassName="color-red"
            bodyClassName="background-color-red text-white"
            show
            fade
            autohide={3000}
            title={""}
            message={Update.message}
            text={"maintenant"}
            style={{
              position: "fixed",
              top: "10px",
              right: "10px",
              zIndex: 9999
            }}
          />
          : null}
      <MDBContainer className="pt-5">
        <MDBRow>
          <MDBCol md={"4"} className="offset-1">
            <Lookup
              id="lookup-1"
              label="Ajouter un titre au classement"
              placeholder="Titre ou artiste"
              value={value}
              debounce={true}
              options={Options}
              onChange={(option: LookupValue | any) => <> {setValue({ label: option?.label, Id: option?.Id, photo: option?.photo, artiste: option?.artiste })}</>}
              onSearch={(value) => { search(value) }}
              isLoading={Loading}
              onClick={() =>setValue("")}
            />
          </MDBCol>
          <MDBCol md={"4"} className="">
            <Picklist
              placeholder="Place dans le top 30"
              label="Place dans le top 30"
              name="Place dans le top 30"
              variant='default'
              value={DropDown}
              onChange={value => { setDropDown({ ...DropDown, label: value.label, name: value?.name }) }}
            >
              {DropDown && DropDown.options.map((data: any, i: number) => (
                <Option key={data} name={`option${data}`} label={`${data}`} value={`${data}`} />
              ))}
            </Picklist>
          </MDBCol>
          <MDBCol md={"2"} className="">
            <Button label="Ajouter" variant="neutral" className="rainbow-m-around_medium" onClick={() => <> {AddMusic()} </>} />
          </MDBCol>
        </MDBRow>
        {Error && Music?.length === 30 ? <p className="text-center mt-2 red-text font-size-0dot65vw">La liste est déja complete</p> : null}
        {Music && Music?.length !== 30 ? <p className="text-center mt-2 red-text font-size-0dot65vw">La liste n'est pas complete</p> : null}

        <MDBRow>
          <MDBCol md={"4"} className="offset-4 mb-5 mt-2">
            {!pending && Music ?
              <List
                values={Music}
                onChange={({ oldIndex, newIndex }) => {autoUpdate(arrayMove(Music, oldIndex, newIndex), oldIndex, newIndex)}}
                renderList={({ children, props }) => <ul {...props}>{children}</ul>}
                renderItem={({ value, props }) =>
                  <li {...props} className="list-unstyled">
                    <Card className="mt-2 d-flex" style={{ height: '5vh' }}>
                      <div className="font-weight-bold font-size-0dot65vw d-flex justify-content-center align-items-center text-white" style={{ backgroundColor: '#2d2180', width: '10%' }}>
                        <p>{props.key !== undefined ? props.key + 1 : null}</p>
                      </div>
                      <div className="w-25">
                        <img className="h-100" src={value.photo}></img>
                      </div>
                      <div className="d-flex align-items-center" style={{ width: '55%' }}>
                        <p className="font-weight-bolder font-size-0dot65vw cut-text-1l">{value.label}</p>
                      </div>
                      <div className="d-flex justify-content-end align-items-center" style={{ width: '10%' }}>
                        <ButtonIcon size="small" className="" icon={<FontAwesomeIcon icon={faTimes} ></FontAwesomeIcon>} onClick={() => { remove(value);/*console.log(value); console.log(Music.findIndex(ele => ele.Id == value.Id))  ;console.log(Music.splice(Music.findIndex(ele => ele.Id == value.Id),1))/*setMusic((prevArray: any) => [...prevArray, prevArray.splice(Music.findIndex(ele => ele.Id == value.Id),1)]);*/ /*setMusic(arrayRemove(Music, value.index)); console.log(arrayRemove(Music, value.index))*/}} />
                      </div>
                    </Card>
                  </li>}
              /> : <></>}
          </MDBCol>
        </MDBRow>

      </MDBContainer>
    </>)
}

export default EdiTop30
